import React from 'react'

import SidebarItem from './SidebarItem'
import styles from './styles.less'

SidebarHeader.propTypes = SidebarItem.propTypes

SidebarHeader.defaultProps = SidebarItem.defaultProps

export default function SidebarHeader(props) {
  return (
    <SidebarItem
      className={styles.SidebarItem_header}
      {...props}
      size="large"
      showBackgroundWhenActive={false}
    />
  )
}
